import {createStyles} from '@mantine/core';
import React from 'react';

import MarkdownContent from 'ui-library/MarkdownContent';

const useStyles = createStyles((theme) => ({
  wrapper: {
    fontSize: theme.fontSizes.sm,
    padding: theme.spacing.sm,
  },
}));

interface MarkdownRendererProps {
  content: string;
}

export default function MarkdownRenderer({content}: MarkdownRendererProps): JSX.Element {
  const {classes} = useStyles();
  return (
    <div className={classes.wrapper}>
      <MarkdownContent content={content} />
    </div>
  );
}
